"use client";

// Lazy client parts of the server-rendered detail sections (event, booking,
// artist, contest, venue). Same reason as components/CMS/lazyClientSections.js:
// a client component imported statically by a server component lands in the
// catch-all route's entry chunks, so every page loaded the checkout (with the
// seating and zone-layout canvases), the event page widgets, Google Maps for
// venues and the contest UI. Imported through here, each loads only on the
// pages that render it; SSR output is unchanged.
import dynamic from "next/dynamic";

// Booking / checkout
export const Booking = dynamic(() => import("./Booking/Booking"));

// Event detail
export const EventSummary = dynamic(() => import("./EventSummary"));
export const EventMedia = dynamic(() => import("./Event/EventMedia"));
export const ImageGallery = dynamic(() => import("./Event/imageGallery"));
export const BannerWithVideo = dynamic(() => import("./Event/bannerWithVideo"));
export const TnCPopup = dynamic(() => import("./Event/tncPopup"));
export const EventFaq = dynamic(() => import("./Event/EventFaq"));
export const GenZSection = dynamic(() => import("./Event/GenZSection"));
export const ShareButton = dynamic(() => import("./shareButton"));
export const ArtistCard = dynamic(() => import("./Artist/ArtisCard"));
export const BackButton = dynamic(() => import("./Event/backButton"));
export const EventSlider = dynamic(() => import("./Event/Event-Section/EventSlider"));

// Artist
export const ArtistHero = dynamic(() => import("./Artist/ArtistHero"));
export const ArtistAchievements = dynamic(() => import("./ArtistAchievements"));
export const ArtistSection = dynamic(() => import("./Artist/ArtistSection"));

// Contest
export const ContestParticipationProvider = dynamic(() =>
  import("./Contest/ContestParticipationContext").then(
    (m) => m.ContestParticipationProvider,
  ),
);
export const ContestHeaderBar = dynamic(() => import("./Contest/ContestHeaderBar"));
export const ContestHeroActions = dynamic(() => import("./Contest/ContestHeroActions"));
export const ContestDescription = dynamic(() => import("./Contest/ContestDescription"));
export const ContestWinners = dynamic(() => import("./Contest/ContestWinners"));
export const ContestTerms = dynamic(() => import("./Contest/ContestTerms"));
export const ContestDetailSidebar = dynamic(() => import("./Contest/ContestDetailSidebar"));
export const ContestSlider = dynamic(() => import("./Contest/ContestSlider"));

// Venue (Google Maps)
export const VenueMain = dynamic(() => import("./venue/Main"));
